<script>
    import LiteCompare from "@/components/lite-compare/LiteCompare";

    export default {
        name: "HomeCompare",
        components: { LiteCompare },
        computed: {
            specifications() {
                return [
                    { name: "Сдутый биван", values: ["220x70 см", "220x70 см"] },
                    { name: "Надутый биван", values: ["190x90x65 см", "180x80x55 см"] },
                    { name: "Вес", values: ["1,5 кг", "1,3 кг"] },
                    { name: "Максимальная нагрузка", values: ["300 кг", "250 кг"] },
                    {
                        name: "Время удержания воздуха",
                        values: ["до 12 часов", "до 12 часов"],
                    },
                    {
                        name: "Большой карман",
                        icons: [{ image: "check.svg" }, { image: "check.svg" }],
                    },
                    {
                        name: "Маленький карман",
                        icons: [{ image: "check.svg" }, { image: "uncheck.svg" }],
                    },
                    { name: "Петелька для колышка", values: ["2 шт.", "2 шт."] },
                    {
                        name: "Дренажная сетка",
                        icons: [{ image: "check.svg" }, { image: "uncheck.svg" }],
                    },
                    {
                        name: "Крепление для подсветки",
                        icons: [{ image: "check.svg" }, { image: "uncheck.svg" }],
                    },
                    {
                        name: "Ремонтопригодность*",
                        icons: [{ image: "check.svg" }, { image: "check.svg" }],
                    },
                ];
            },
        },
    };
</script>

<template>
    <section class="home-compare-lite">
        <h2 class="home-compare-lite__title page-title">Отличия моделей</h2>
        <div class="home-compare-lite__wrapper">
            <lite-compare
                :specifications="specifications"
                :products-ids="[76061, 107297]"
                :header-top-margin="64"
                :header-start-position="{ mobile: 300, desktop: 400 }"
            ></lite-compare>
        </div>
    </section>
</template>

<style lang="scss">
    .home-compare-lite {
        padding: 20px;
        border-radius: var(--border-lg);
        border: 2px solid var(--primary-border);
        @include bp($bp-desktop-sm) {
            padding: 40px 20px;
            border-radius: var(--border-xl);
        }
        @include bp($bp-desktop-md) {
            padding: 40px;
        }
    }

    .home-compare-lite__title {
        &.page-title {
            margin-bottom: 0;
        }
    }
</style>
